import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMortarboardFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M19 12.2816V14.0001C19 17.8661 15.8659 21.0001 12 21.0001C8.13396 21.0001 4.99995 17.8661 4.99995 14.0001V12.2816L11.3588 15.2885C11.7647 15.4804 12.2353 15.4804 12.6413 15.2885L19 12.2816ZM12.6413 2.71184L21.7216 7.00564C22.4551 7.35249 22.5479 8.30796 22 8.80876V13.0001C22 13.5524 21.5522 14.0001 21 14.0001C20.4477 14.0001 20 13.5524 20 13.0001V9.80862L12.6413 13.2883C12.2353 13.4803 11.7647 13.4803 11.3588 13.2883L2.27845 8.99449C1.43874 8.59743 1.43877 7.4027 2.27845 7.00564L11.3588 2.71184C11.7647 2.51988 12.2353 2.51988 12.6413 2.71184Z" })
});
export default SvgMortarboardFill;
